import { Client } from '@/pages/user/api';
let apiPrefix = 'portal';

/**
 * 5.1 查询省份接口
 */
export const GetProvinces = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/area/queryProvinces',
  });
};

/**
 * 5.2 查询城市接口
 */
export const GetCity = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/area/queryCities',
    data,
  });
};
/**
 * 5.3 查询区县接口
 */
export const GetDistrict = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/area/queryDistrict',
    data,
  });
};

/**
 * 文件上传
 */
export const getObsToken = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/obs/token',
    data,
  });
};

/**
 * 查询全部工具树
 */
export const GetTools = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/tool/queryAll',
    data,
  });
};

/**
 * 查询跳转路径
 */
export const GetTooDetail = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/tool/detail',
    data,
  });
};

/**
 * 查询跳转路径
 */
export const GetToolUrl = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/tool/url',
    data,
  });
};

/**
 * 文件下载
 */
export const DownLoadFile = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/scan/file/download',
    data,
  });
};

/**
 * 2.5 通用文字识别
 */
export const Recognize = async (data: any): Promise<any | null> => {
  return await Client.upload<any>({
    url: apiPrefix + '/tool/ocr/recognize',
    data,
  });
};
/**
 * 通用文字识别
 */
export const RecognizeTable = async (data: any): Promise<any | null> => {
  return await Client.upload<any>({
    url: apiPrefix + '/tool/ocr/recognizeTable',
    data,
  });
};

/**
 * 查询权益列表
 */
export const GetRightsList = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/rights/list',
    data,
  });
};

/**
 * 查询企业网盘
 */
export const GetSpaceRights = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/enterprise/disk/info',
  });
};

/**
 * 查询企业工具权益
 */
export const GetToolRights = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/enterprise/tool/info',
  });
};

/**
 * 查询渠道门户配置
 */
export const GetchannelSetting = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/channel/portal/setting/current',
  });
};
